export enum SWITCHES_SIZE {
  DEFAULT = 'default',
  LARGE = 'large'
}
